export { default } from './CardMedia';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/CardMedia/index.js
// module id = 790
// module chunks = 121